import { getApp, getApps, initializeApp } from "firebase/app";

export const firebaseConfig = {
  apiKey: "AIzaSyAPpqo63bf_4CnkXL0fs9JAinEgus4-gkM",
  authDomain: "www.chuno.work",
  projectId: "chuno-work-2026",
  storageBucket: "chuno-work-2026.firebasestorage.app",
  messagingSenderId: "103034284568",
  appId: "1:103034284568:web:496937a9b05472b32a316d",
};

export const firebaseApp = getApps().length ? getApp() : initializeApp(firebaseConfig);
